import React from 'react';
import { Plane, Calendar, AlertTriangle, CheckCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const getIncidentLabel = (type) => {
  const labels = {
    delay: 'Flight Delay',
    cancel: 'Cancellation',
    denied_boarding: 'Denied Boarding',
  };
  return labels[type] || type || 'Not specified';
};

const getIncidentVariant = (type) => {
  const variants = {
    delay: 'warning',
    cancel: 'error',
    denied_boarding: 'warning',
  };
  return variants[type] || 'secondary';
};

const formatDate = (dateString) => {
  if (!dateString) return 'Not specified';
  if (dateString.includes('T') || dateString.includes('-')) {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  return dateString;
};

const InfoItem = ({ icon: Icon, label, children, iconClassName = 'text-slate-400' }) => (
  <div>
    <div className="flex items-center gap-1.5 mb-1">
      <Icon className={`h-3.5 w-3.5 ${iconClassName}`} />
      <span className="text-xs text-slate-500">{label}</span>
    </div>
    {children}
  </div>
);

const CaseOverviewSection = ({ caseData }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
      <InfoItem icon={AlertTriangle} label="Incident Type" iconClassName="text-orange-500">
        <Badge variant={getIncidentVariant(caseData.incident_type)} className="text-sm">
          {getIncidentLabel(caseData.incident_type)}
        </Badge>
      </InfoItem>

      <InfoItem icon={Calendar} label="Incident Date" iconClassName="text-blue-500">
        <p className="font-medium">{formatDate(caseData.incident_date)}</p>
      </InfoItem>

      <InfoItem icon={Plane} label="Airline" iconClassName="text-cyan-500">
        <p className="font-medium text-lg">{caseData.airline_code || 'Not specified'}</p>
      </InfoItem>

      <InfoItem icon={CheckCircle} label="Progress" iconClassName="text-green-500">
        <div className="flex items-center gap-2">
          <span className="font-medium">{caseData.passenger_count || 0} pax</span>
          <span className="text-slate-400">•</span>
          <span className="font-medium">{caseData.flight_segment_count || 0} flights</span>
        </div>
      </InfoItem>
    </div>
  );
};

export default CaseOverviewSection;
